module.exports = __webpack_public_path__ + "3-70.jpg?a34f1139ebd7c361cb5a5a72ac054bbc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-70.jpg
// module id = 152
// module chunks = 0